import { render, staticRenderFns } from "./LandingArea.vue?vue&type=template&id=0498f44b&scoped=true&"
import script from "./LandingArea.vue?vue&type=script&lang=js&"
export * from "./LandingArea.vue?vue&type=script&lang=js&"
import style0 from "./LandingArea.vue?vue&type=style&index=0&id=0498f44b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0498f44b",
  null
  
)

export default component.exports